import {useQuery} from "@tanstack/react-query";
import { dishSettingsLoad } from '../../../store/Dish/api';

export const useGetDishInputOptions = ({ slug }) => {
    return useQuery(["dish-input-options"], () => dishSettingsLoad({ slug }), {
        staleTime: 0,
        cacheTime: 0
    });
}
